<template>
  <div>
    <NewsFull :path="$route.path" />
  </div>
</template>
